import { useMemo, useState } from 'react';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { RatingReviewOrderBy } from '@graphql/generated';

export type UseReviewOrderingReturn = ReturnType<typeof useReviewSorting>;

export const useReviewSorting = () => {
  const orderingOptions = useMemo(() => {
    return [
      {
        id: RatingReviewOrderBy.newest,
        label: 'Most Recent',
        value: RatingReviewOrderBy.newest,
      },
      {
        id: RatingReviewOrderBy.ratingDesc,
        label: 'Highest Rating',
        value: RatingReviewOrderBy.ratingDesc,
      },
      {
        id: RatingReviewOrderBy.ratingAsc,
        label: 'Lowest Rating',
        value: RatingReviewOrderBy.ratingAsc,
      },
    ];
  }, []);
  const [currentOrderingOption, setOrdering] = useState<(typeof orderingOptions)[number]>(orderingOptions[0]);

  const handleOnSetReviewOrdering = useEventCallback((opt: (typeof orderingOptions)[number] | null) => {
    if (opt) {
      setOrdering(opt);
    }
  });

  return {
    orderingOptions,
    currentOrderingOption,
    handleOnSetReviewOrdering,
  };
};
